/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'reportRoute',
  initialState: {
    items: {}
  },
  reducers: {
    update(state, action) {
      state.items = action.payload;
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as reportRouteActions };
export { reducer as reportRouteReducer };

/*-------------------------------------------------------------------------------------------*/
